import { render, staticRenderFns } from "./ReporteStockShowData.vue?vue&type=template&id=3dff40cf"
import script from "./ReporteStockShowData.vue?vue&type=script&lang=js"
export * from "./ReporteStockShowData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports